<div class="cointainer-fluid">
  <div class="row">
    <div class="col">
      <h2 i18n="@@DialogProductNotFoundCaption">
        <mat-icon style="vertical-align: middle">error</mat-icon>&nbsp;Attenzione</h2>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <p i18n="@@DialogProductNotFoundText">
        Se il certificato non viene trovato, anche dopo verifica dei dati inseriti, è possibile inoltrare la richiesta al nostro
        servizio clienti, che Vi risponderà al più presto possibile.
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div style="text-align: center">
        <button mat-raised-button (click)="closeDialog()" i18n="@@DialogClose" color="default">Chiudi</button>&nbsp;
        <button mat-raised-button (click)="closeDialog(true)" i18n="@@DialogSendToCustomerService" color="primary">Invia richiesta al customer service</button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/dialogs/product-not-found-dialog/product-not-found-dialog.html